// Download via a short-lived GCS V4 signed URL inside a HIDDEN IFRAME so the SPA/list is never
// replaced — not on success (Content-Disposition: attachment makes the browser download silently,
// no Google page is shown) and not on error (GCS's XML error body loads inside the hidden iframe).
// The iframe's `load` event only fires when GCS serves a viewable document (i.e. an error), never
// for an attachment download — so we use it as a best-effort failure signal without needing bucket
// CORS to read the cross-origin response. No fetch/blob (would need CORS + could leak our auth header).
export const triggerHiddenIframeDownload = (url: string, onLikelyError: () => void) => {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  let settled = false;
  const cleanup = () => {
    window.clearTimeout(timer);
    iframe.remove();
  };
  iframe.onload = () => {
    if (settled) return;
    settled = true;
    onLikelyError();
    cleanup();
  };
  // Success path fires no load event; reclaim the iframe after a grace period.
  const timer = window.setTimeout(() => {
    if (settled) return;
    settled = true;
    cleanup();
  }, 30000);
  iframe.src = url;
  document.body.appendChild(iframe);
};
